
import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { DigisubservicesService } from 'src/app/services/digisubservices.service';

@Component({
  selector: 'app-issue-seller-pincodewise-statement',
  templateUrl: './issue-seller-pincodewise-statement.component.html',
  styleUrl: './issue-seller-pincodewise-statement.component.scss'
})

export class IssueSellerPincodewiseStatementComponent implements OnInit {
  pincodewisedata;
  total_pin_sub_count = 0;
  totalparcel = 0;
  totalanksankhya = 0;
  filteredpincodewisesubcout = [];
  pincodewisesubcoutprinting = [];
  sundayankDate;
  dispatchankDate;

  constructor(
    private dialogref: MatDialogRef<IssueSellerPincodewiseStatementComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private service: DigisubservicesService
  ) { }
  updateStatus: any = false
  issuedate: any
  state: any
  district: any
  ngOnInit(): void {
    this.pincodewisedata = this.data['data'];
    this.sundayankDate = this.data['sundaydate'];
    this.dispatchankDate = this.data['dispatchdate'];
    this.updateStatus = this.data['updateStatus']
    this.issuedate = this.data['issueDate']
    this.state = this.data.state;
    this.district = this.data.district;
    // console.log('pincodewisedata', this.pincodewisedata);



    if (this.updateStatus) {
      this.getPincodewiseEntryCheck();
      this.total_pin_sub_count = 0;
      this.totalparcel = 0;
      this.totalanksankhya = 0;
      let tempdata = this.uniqueid(this.pincodewisedata, (a) => a['pincode']);

      // console.log({ tempdata });
      this.filteredpincodewisesubcout = [];
      for (let index = 0; index < Object.keys(tempdata).length; index++) {
        let arr = this.pincodewisedata.filter(
          (a) => a['pincode'] == tempdata[index]['pincode']
        );
        // console.log('*********Started***********');
        // console.log({ arr });

        let delivery_mode_unique = this.uniqueid(arr, (a) => a['delivery_mode']);
        // console.log({ delivery_mode_unique });

        let totalTapalCount = 0;
        let parcelval = 0;
        let anksankhya = 0;
        for (let j = 0; j < Object.keys(delivery_mode_unique).length; j++) {
          let arr1 = arr.filter(
            (a) => a['delivery_mode'] == delivery_mode_unique[j]['delivery_mode']
          );
          // console.log({ arr1 });
          let hasteTapalJPO = [];
          if (arr1[0]['delivery_mode'] === 'टपाल') {
            totalTapalCount = Object.keys(arr1).length;
            // console.log({ totalTapalCount });
          } else if (arr1[0]['delivery_mode'] === 'हस्ते') {
            // console.log('this might be hand delivery');

            hasteTapalJPO = arr1.filter(
              (a) => a['dis_mode'] == 'टपाल' && a['dis_sub_mode'] == 'जी.पी.ओ'
            );
            // console.log({ hasteTapalJPO });
            if (hasteTapalJPO.length > 0) {
              let hasteTapalJPOUnique = this.uniqueid(
                hasteTapalJPO,
                (a) => a['distribution_rep']
              );
              // console.log({ hasteTapalJPOUnique });
              parcelval = hasteTapalJPOUnique.length;
              hasteTapalJPOUnique.map((tapal) => {
                let ank = hasteTapalJPO.filter(
                  (a) => a['distribution_rep'] === tapal['distribution_rep']
                );
                // console.log({ ank });
                anksankhya += ank.length;
              });
              // console.log({ anksankhya });
            }
          }
        }
        // console.log({ totalTapalCount });
        // console.log('*********Ended***********');

        this.filteredpincodewisesubcout.push({
          name: tempdata[index]['name'],
          Subscription_Type: tempdata[index]['Subscription_Type'],
          address: tempdata[index]['address'],
          country: tempdata[index]['country'],
          delivery_mode: tempdata[index]['delivery_mode'],
          district: tempdata[index]['district'],
          pincode: tempdata[index]['pincode'],
          state: tempdata[index]['state'],
          sub_perid_to_date: tempdata[index]['sub_perid_to_date'],
          taluka: tempdata[index]['taluka'],
          sub: totalTapalCount,
          parcel: `${parcelval}=${anksankhya}`,
        });

        this.total_pin_sub_count += totalTapalCount;
        this.totalparcel += parcelval;
        this.totalanksankhya += anksankhya;
      }

      // console.log('filteredpincodewisesubcout', this.filteredpincodewisesubcout);

      let totalcount = Object.keys(this.filteredpincodewisesubcout).length;
      let tempcount = Math.ceil(totalcount / 3);
      // console.log(Math.ceil(totalcount / 3));
      let val = 0;
      let a = 0;
      let b = 1;
      let c = 2;
      for (let i = 0; i < tempcount; i++) {
        val += 3;
        this.pincodewisesubcoutprinting.push({
          pincode1: 0,
          sub1: 0,
          parcel1: 0,
          pincode2: 0,
          sub2: 0,
          parcel2: 0,
          pincode3: 0,
          sub3: 0,
          parcel3: 0,
        });
        for (
          let index = 0;
          index < Object.keys(this.filteredpincodewisesubcout).length;
          index++
        ) {
          if (index < val) {
            // console.log('val works');
            if (index == a) {
              // console.log('a works');

              this.pincodewisesubcoutprinting[i]['pincode1'] =
                this.filteredpincodewisesubcout[index]['pincode'];
              this.pincodewisesubcoutprinting[i]['sub1'] =
                this.filteredpincodewisesubcout[index]['sub'];
              this.pincodewisesubcoutprinting[i]['parcel1'] =
                this.filteredpincodewisesubcout[index]['parcel'];
            } else if (index == b) {
              // console.log('b works');

              this.pincodewisesubcoutprinting[i]['pincode2'] =
                this.filteredpincodewisesubcout[index]['pincode'];
              this.pincodewisesubcoutprinting[i]['sub2'] =
                this.filteredpincodewisesubcout[index]['sub'];
              this.pincodewisesubcoutprinting[i]['parcel2'] =
                this.filteredpincodewisesubcout[index]['parcel'];
            } else if (index == c) {
              // console.log('c works');

              this.pincodewisesubcoutprinting[i]['pincode3'] =
                this.filteredpincodewisesubcout[index]['pincode'];
              this.pincodewisesubcoutprinting[i]['sub3'] =
                this.filteredpincodewisesubcout[index]['sub'];
              this.pincodewisesubcoutprinting[i]['parcel3'] =
                this.filteredpincodewisesubcout[index]['parcel'];
            } else {
              // console.log('continue works');

              continue;
            }
          }
        }

        a += 3;
        b += 3;
        c += 3;
      }
    } else {
      this.getPincodeStatementList();
    }
    // console.log('pincodewisesubcoutprinting', this.pincodewisesubcoutprinting);
  }

  uniqueid(data, key) {
    return [...new Map(data.map((x) => [key(x), x])).values()];
  }

  getPincodeStatementList() {
    this.pincodewisesubcoutprinting=[]
    const request = {
      issue_date: this.issuedate,
      country: "भारत",
      district: this.district[0],
      state: this.state[0]
    }
    this.service.getIssueSellerPincodewiseStatementList(request).subscribe((data: any) => {
      this.pincodewisesubcoutprinting = data;
      this.total_pin_sub_count=data[0].total_sub123;
      this.totalparcel=data[0].parcel_total;
      this.totalanksankhya=data[0].book_bundle_total;
    });
  }

  existCount:any
  getPincodewiseEntryCheck() {
    const request = {
      issue_date: this.issuedate,
      country: "भारत",
      district: this.district[0],
      state: this.state[0]
    }
    this.service.getIssueSellerPincodewiseEntryCheck(request).subscribe((data: any) => {
      this.existCount=data[0].RECORD_COUNT;
      if(this.existCount!=0){
        alert(this.existCount+" Records Are Already saved");
      }
     
    });
  }


  saveSubscriptionBarcodesDataEntry() {
    console.log(this.pincodewisesubcoutprinting);
    const filteredData = this.pincodewisesubcoutprinting.map((item) => ({
      issue_date: this.convertDateFormat1(this.sundayankDate),
      country: "भारत",
      state: this.state[0],
      added_by: 1,
      publish_date: this.convertDateFormat(this.dispatchankDate),
      delivery_mode: item.delivery_mode,
      dispatch_date: this.convertDateFormat(this.dispatchankDate),
      district: this.district[0],


      pincode1: item.pincode1,
      no_of_book_bundle1: item.parcel1 != undefined ? item.parcel1.split("=")[1] : "",
      count_bundle1: item.parcel1 != undefined ? item.parcel1.split("=")[0] : "",
      no_subscriber1: item.sub1,
      total1: this.total_pin_sub_count,

      pincode2: item.pincode2,
      no_of_book_bundle2: item.parcel2 != undefined ? item.parcel2.split("=")[1] : "",
      count_bundle2: item.parcel2 != undefined ? item.parcel2.split("=")[0] : "",
      no_subscriber2: item.sub2,
      total2: this.total_pin_sub_count,

      pincode3: item.pincode3,
      no_of_book_bundle3: item.parcel3 != undefined && item.parcel3 != 0 && item.parcel3 != "" && item.parcel3 != null ? item.parcel3.split("=")[1] : "",
      count_bundle3: item.parcel3 != undefined && item.parcel3 != 0 && item.parcel3 != "" && item.parcel3 != null ? item.parcel3.split("=")[0] : "",
      no_subscriber3: item.sub3,
      total3: this.total_pin_sub_count,
    }));
    console.log(filteredData);
    this.service.saveIssueSellerPincodewiseStatement(filteredData).subscribe((data) => {
      alert('Pincodewise Statements Save Successfully!');
    });
  }
  convertDateFormat(dateStr: string): string {
    const [day, month, year] = dateStr.split('/');
    return `${year}/${month}/${day}`;
  }
  convertDateFormat1(dateStr: string): string {
    const date = new Date(dateStr);
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, '0'); // Months are 0-based
    const day = String(date.getDate()).padStart(2, '0');
  
    return `${year}/${month}/${day}`;
  }
  
  deletePincodewiseStatementList() {
    const request = {
      ids: this.selectedIds
    }
    this.service.deleteIssueSellerPincodewiseStatement(request).subscribe((data: any) => {

     alert(data.message);
     this.getPincodeStatementList();
    });
  }


  checkAll = false;
  masterSelected: boolean = false;
  selectedIds: any = ""
  deleteDistrictwiseStatemet: any = true;
  checkUncheckAll() {
    this.selectedIds = ""
    this.checkAll = !this.checkAll;
    this.pincodewisesubcoutprinting.forEach(item => item.selected = this.checkAll);

    this.pincodewisesubcoutprinting.forEach((element: any) => {
      if (element.selected) {
        if (this.selectedIds == "") {
          this.selectedIds = element.id
        } else {
          this.selectedIds = this.selectedIds + "," + element.id
        }
      }

    });
    // alert(this.selectedIds)
    if (this.selectedIds == "") {
      this.deleteDistrictwiseStatemet = true;
    } else {
      this.deleteDistrictwiseStatemet = false;
    }
  }
  isAllSelected() {
    this.selectedIds = ""
    this.masterSelected = this.pincodewisesubcoutprinting.every(item => item.selected);
    this.pincodewisesubcoutprinting.forEach((element: any) => {
      if (element.selected) {
        if (this.selectedIds == "") {
          this.selectedIds = element.id
        } else {
          this.selectedIds = this.selectedIds + "," + element.id
        }
      }

    });
    if (this.selectedIds == "") {
      this.deleteDistrictwiseStatemet = true;
    } else {
      this.deleteDistrictwiseStatemet = false;
    }
    // alert(this.selectedIds)
  }

}
